import React, { useState } from "react";
import axios from "axios";
import { useNavigate, Link } from "react-router-dom";
import { EyeIcon, EyeOffIcon } from "lucide-react";
import Swal from "sweetalert2";

const Login = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [msg, setMsg] = useState("");
  const navigate = useNavigate();
  
  const [showPassword, setShowPassword] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setMsg("");

    try {
      const response = await axios.post(`${process.env.REACT_APP_BASE_URL}api/login`, {
        email,
        password,
      });

      if (response.data.status === "success") {
        localStorage.setItem("user", JSON.stringify(response.data.user));
        Swal.fire('Berhasil !', 'Berhasil login', 'success');
        navigate("/admin");
        // Simpan token/user ke localStorage atau state
      }
    } catch (error) {
      if (error.response && error.response.data) {
        const msg =
          error.response.data.message ||
          error.response.data.messages?.error ||
          "Login gagal";
        setMsg(msg);
      }
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-slate-950 ">
      <div className="w-full max-w-md bg-white p-8 rounded-xl shadow-lg">
        <div className="flex justify-center w-full p-8">
          <img src="/images/Logo RP.png" alt="Logo" />
        </div>
        {msg && <div className="mb-4 text-red-500 text-sm">{msg}</div>}
        <form onSubmit={handleSubmit} className="space-y-4 py-4">
          <div>
            <label className="block mb-1 font-medium text-gray-700">Email</label>
            <input
              type="email"
              className="w-full border px-3 py-2 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
          </div>
          <div>
            <label className="block mb-1 font-medium text-gray-700">Password</label>
            <div className="relative">
              <input
                type={showPassword ? "text" : "password"}
                className="w-full border px-3 py-2 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
              />
              <button
                  type="button"
                  className="absolute inset-y-0 right-3 flex items-center text-gray-500 hover:text-gray-700"
                  onClick={() => setShowPassword(!showPassword)}
                >
                  {showPassword ? <EyeOffIcon size={18} /> : <EyeIcon size={18} />}
              </button>
            </div>
          </div>
          <button
            type="submit"
            className="w-full text-white py-4 rounded-full bg-gradient-to-r from-blue-600 to-red-600 rounded-full font-semibold hover:shadow-lg hover:shadow-blue-500/50 transform hover:scale-105 transition-all duration-300"
          >
            Login
          </button>
          
        </form>
        {/* <div className="flex py-4 gap-2">
          <Link
          className="text-blue-600 text-underline-offset"
              to="/register"
            >
              Daftar Akun
            </Link>
            <div>
              <Link
          className="text-blue-600 text-underline-offset"
                to="https://backend.mxmfinance.com/forgot"
              >
                Lupa Password?
              </Link>

            </div>
        </div> */}
        
      </div>
    </div>
  );
};

export default Login;
